import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import destinationStyle from './destination-service.module.less';

const DestinationService = ({ children, className = '' }) => (
  <p className={classnames(destinationStyle['destination-service'], className)}>{children}</p>
);

DestinationService.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default DestinationService;
